var _rect, _path, _path2, _rect2, _rect3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadFilesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 171,
    viewBox: "0 0 132 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 112,
    width: 17,
    height: 36,
    rx: 2,
    fill: "#B55BFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.3109 169.876C74.9117 170.429 74.0882 170.429 73.6891 169.876L56.1585 145.585C55.6812 144.924 56.1537 144 56.9693 144L92.0307 144C92.8463 144 93.3188 144.924 92.8415 145.585L75.3109 169.876Z",
    fill: "#B55BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 31C0 26.5817 3.58172 23 8 23H58C62.4183 23 66 26.5817 66 31V53C66 57.4183 62.4183 61 58 61H8C3.58172 61 0 57.4183 0 53V31Z",
    fill: "#B55BFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 74,
    width: 77,
    height: 6,
    rx: 3,
    fill: "#DAADFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 92,
    width: 77,
    height: 6,
    rx: 3,
    fill: "#DAADFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7866 0H22C18.6865 0 16 2.68628 16 6V18H24V8H80V45.6332C80 48.9469 82.6865 51.6332 86 51.6332H124V146H96.2367L90.4982 154H126C129.313 154 132 151.314 132 148V52.2132L79.7866 0ZM57.5018 154L51.7633 146H24V66H16V148C16 151.314 18.6865 154 22 154H57.5018Z",
    fill: "#DAADFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFilesIcon);
export default __webpack_public_path__ + "static/media/download-files-icon.18843c8af88e390ac7091e4a455901e1.svg";
export { ForwardRef as ReactComponent };